export const MODULE = "new/purchase-products-modal";
